module.exports = __webpack_public_path__ + "img/DE00229.30e418c4.png";